import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';

import { MfaIssueQueryVariables } from '../MfaIssue.generated';

const ISSUE_ID_PARAM_NAME = 'issueId';
const RUN_ID_PARAM_NAME = 'runId';

export const buildMfaIssueVariables = (issueId: string, runId: string): MfaIssueQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MfaIssueQueryVariables>();

	return variablesBuilder
		.addConditionParam(ISSUE_ID_PARAM_NAME, issueId)
		.addConditionParam(RUN_ID_PARAM_NAME, runId)
		.getVariables();
};
